import { useEffect } from "react";

export default function Header() {
    useEffect(() => {
        // Inicializar o menu mobile quando o componente montar
        const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
        const navmenu = document.querySelector("#navmenu");

        if (mobileNavToggle && navmenu) {
            const toggleMobileNav = () => {
                document.body.classList.toggle("mobile-nav-active");
                mobileNavToggle.classList.toggle("bi-list");
                mobileNavToggle.classList.toggle("bi-x");
            };

            mobileNavToggle.addEventListener("click", toggleMobileNav);

            // Fechar menu ao clicar em um link
            const navLinks = navmenu.querySelectorAll("a");
            navLinks.forEach((link) => {
                link.addEventListener("click", () => {
                    if (document.body.classList.contains("mobile-nav-active")) {
                        toggleMobileNav();
                    }
                });
            });

            // Cleanup
            return () => {
                mobileNavToggle.removeEventListener("click", toggleMobileNav);
            };
        }
    }, []);

    return (
        <header id="header" className="header d-flex align-items-center sticky-top">
            <div className="container position-relative d-flex align-items-center justify-content-between">
                <a href="index.html" className="logo d-flex align-items-center me-auto me-xl-0">
                    <h1 className="sitename me-2 text-business">VRL Sistemas & Tecnologias</h1>

                    {/* <span>
                        <Icon path={mdiCodeBlockTags} size={1} />
                    </span> */}
                </a>

                <nav id="navmenu" className="navmenu">
                    <ul>
                        <li>
                            <a href="#hero">Início</a>
                        </li>
                        <li>
                            <a href="#services">Atuação</a>
                        </li>
                        <li>
                            <a href="#tecnologias">Tecnologias</a>
                        </li>
                        <li>
                            <a href="#processo">Processo</a>
                        </li>
                        <li>
                            <a href="#diferenciais">Diferenciais</a>
                        </li>

                        {/* Dropdown Menu 
            <li className="dropdown"><a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="#">Dropdown 1</a></li>
                <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                    <ul>
                    <li><a href="#">Deep Dropdown 1</a></li>
                    <li><a href="#">Deep Dropdown 2</a></li>
                    <li><a href="#">Deep Dropdown 3</a></li>
                    <li><a href="#">Deep Dropdown 4</a></li>
                    <li><a href="#">Deep Dropdown 5</a></li>
                    </ul>
                </li>
                <li><a href="#">Dropdown 2</a></li>
                <li><a href="#">Dropdown 3</a></li>
                <li><a href="#">Dropdown 4</a></li>
                </ul>
            </li>
            */}
                        <li>
                            <a href="#contact">Contato</a>
                        </li>
                    </ul>
                    <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                </nav>

                {/*<a className="btn-getstarted" href="index.html#about"> <Icon className='me-2' path={mdiFrequentlyAskedQuestions} size={1} /> F.A.Q</a>*/}
            </div>
        </header>
    );
}
